import { mapMarker as icon } from '@wordpress/icons';
import initBlock from '../utils/init-block';
import metadata from './block.json';
import edit from './edit';
import deprecated from './deprecated';
import transforms from './transforms';

const { name } = metadata;
export { metadata, name };

export const settings = {
	icon,
	example: {
		viewportWidth: 350,
		attributes: {
			style: {
				typography: {
					textAlign: 'center',
				},
			},
		},
	},
	edit,
	transforms,
	deprecated,
};

export const init = () => initBlock( { name, metadata, settings } );
